import { render } from "./np-application-breadcrumb.vue?vue&type=template&id=5cb0d612&scoped=true"
import script from "./np-application-breadcrumb.vue?vue&type=script&lang=js"
export * from "./np-application-breadcrumb.vue?vue&type=script&lang=js"

import "./np-application-breadcrumb.vue?vue&type=style&index=0&id=5cb0d612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb0d612"]])

export default __exports__